import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-warning-popup',
  templateUrl: './warning-popup.html',
  styleUrls: ['./warning-popup.scss']
})
export class WarningPopup implements OnInit {

  constructor(private dialogRef: MatDialogRef<WarningPopup>,
    @Inject(MAT_DIALOG_DATA)
    public data: { message: string; type?: string}) { }

  ngOnInit(): void {
  }
  
  onNoClick(click): void {
    this.dialogRef.close(click);
  }

}
